import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { Controller, useForm, useFormContext } from "react-hook-form"
import { FilterMatchMode } from "primereact/api"
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as myconst from "../../../constants/index"
import ParamsPopUp from "../Params-Info-popup";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { infoIcon } from "assets/icons";

interface Field {
    key: string;
    type: 'text' | 'dropdown' | 'password';
    label?: any
}

const MiddleLayer1 = ({ methods, fieldData, clientVersion }: any) => {

    const {
        // formState: { errors },
        control,
        getValues
    } = useForm()

    const { register, setValue, formState: { errors } } = useFormContext()


    const options = [
        { name: "Text" }, { name: "mongodb" }
    ];

    const feilds = myconst.feilds;
    const [selectedCity, setSelectedCity] = useState("")
    const [modalContent, setModalContent] = useState('');
    const [globalFilterValue, setGlobalFilterValue] = useState("")
    const [filters, setFilters] = useState<{ [s: string]: any }>()
    // const filteredData = feilds.filter(item => !item.hasOwnProperty('tempKey'));
    const [initialFields, setInitialFields] = useState(feilds);

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e?.target?.value
        let _filters = { ...filters }

        _filters["global"]!.value = value

        setFilters(_filters)
        setGlobalFilterValue(value)
    }

    const getFormErrorMessage = (name: any) => {
        return (
            errors[name] && (
                <small className="p-error">{errors[name]?.message?.toString()}</small>
            )
        )
    }

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        })
        setGlobalFilterValue("")
    }
    useEffect(() => {
        initFilters()
    }, [])

    const logSource = getValues("log_source");

    useEffect(() => {
        if (logSource === "Text") {
            // setInitialFields(filteredData);
        } else {
            // setInitialFields(feilds);
        }
    }, [selectedCity])


    const getErrorMessage = (errorKey: string): string => {
        const nestedKeys = errorKey.split('.');
        let currentError: any = errors;

        for (const key of nestedKeys) {
            if (currentError && typeof currentError === 'object' && key in currentError) {
                currentError = currentError[key];
            } else {
                return ''; // Return an empty string if the nested key is not found
            }
        }

        return currentError?.message || '';
    };


    return (
        <>
            <div className="datatable-wrapper">
                <div className="w-full mb-3">
                    <IconField iconPosition="right" className='user-input'>
                        <InputIcon className="pi pi-search"> </InputIcon>
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            autoComplete='off'
                            placeholder="Search by parameter"
                            onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                            className='search-bar-input w-full'
                        />
                    </IconField>
                </div>
                <DataTable
                    filters={filters}
                    globalFilterFields={["label"]}
                    showGridlines
                    value={initialFields}
                    emptyMessage="No fields found."
                    scrollable={true}
                    scrollHeight='410px'
                >
                    <Column
                        header="Category"
                        field="category"
                        style={{ minWidth: '150px' }}
                    />

                    <Column
                        field="label"
                        header="Parameter"
                        style={{ minWidth: '350px' }}
                        sortable
                        body={(rowData: any, options: { rowIndex: number }) => {
                            const targetId = `tooltip-${options.rowIndex}`; // Unique identifier based on index
                            return (
                                <>
                                    <span className="header-tooltip">
                                        <span className={`tooltip-target-${options.rowIndex}`}>
                                            {rowData.label}
                                            <span className=" mr-2" style={{color: "#FF5155"}}>*</span>
                                            <i
                                                data-bs-toggle="modal"
                                                data-bs-target="#Params-Info"
                                                onClick={() => setModalContent(rowData.toolTipInfo)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <img src={infoIcon} alt='info-icon' />
                                            </i>
                                        </span>
                                    </span>
                                </>
                            );
                        }}
                    ></Column>
                    <Column
                        header="Field 1"
                        field='field1'
                        style={{ minWidth: '150px' }}
                    />
                    <Column
                        header="Field 2"
                        field='field2'
                        style={{ minWidth: '150px' }}
                    />

                    <Column
                        header="Value"
                        style={{ minWidth: '600px' }}
                        body={(rowData, index) => (
                            <>
                                {
                                    (rowData.type !== "dropdown") ?
                                        (<>
                                            <Controller
                                                name={rowData.key}
                                                control={methods.control}
                                                rules={{
                                                    required: `${rowData.label} is required`
                                                }}
                                                render={({ field }) => (
                                                    <>
                                                        <div className="param-tab-form">
                                                            <div className='form-row'>
                                                                <div className='form-col'>
                                                                    <InputText className="w-full" disabled={clientVersion !== "" ? true : false} type={`${rowData.type}`}
                                                                        {...field}
                                                                        placeholder={rowData.type === "number" ? "Enter Number" : rowData.type === "password" ? "Enter your password" : "Enter your Text here"} />
                                                                    <p style={{color: "#FF5155"}}>{getErrorMessage(rowData.key)}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            />
                                        </>)
                                        :
                                        (<>
                                            <Controller
                                                name={rowData.key}
                                                control={methods.control}
                                                // defaultValue={null}
                                                rules={{ required: 'Please select a log source' }}
                                                render={({ field }) => (
                                                    <div className="param-tab-form">
                                                        <div className='form-row'>
                                                            <div className='form-col'>
                                                                <Dropdown
                                                                    id={rowData.key}
                                                                    onChange={(e) => {
                                                                        field.onChange(e.target.value)
                                                                        setSelectedCity(e.target.value)
                                                                        const filteredData = feilds.filter(item => !item.hasOwnProperty('tempKey'));
                                                                        setInitialFields(e.target.value.name === "Text" ? filteredData : feilds)
                                                                    }}
                                                                    disabled={clientVersion !== "" ? true : false}
                                                                    value={field.value}
                                                                    optionLabel="name"
                                                                    placeholder="Select Log source"
                                                                    options={options}
                                                                    className={`w-100`}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            />
                                            <p  style={{color: "#FF5155"}}>
                                                {errors[`${rowData.key}`]?.message?.toString()}
                                            </p>
                                        </>)
                                }
                            </>
                        )}
                    />
                </DataTable >
            </div >
            <ParamsPopUp content={modalContent} />
        </>
    );

};

export default MiddleLayer1;